import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';
import { IconArrowDown, IconArrowUp, IconDragHandle } from '~/ui/core/icons';

import { profileTaskTranslationKeys } from '../profile-task-translations';

export const WorkflowReorder: FunctionComponent<{
    readonly index: number;
    readonly total: number;
    readonly onMove: (nextIndex: number) => void;
}> = ({ index, onMove, total }) => {
    const translate = useTranslate();

    return (
        <div className="flex shrink-0 items-center gap-xxs">
            <IconDragHandle aria-hidden={true} className="text-text-content-subtle" size={16} />
            <Button
                aria-label={translate(profileTaskTranslationKeys.moveUp)}
                aria-disabled={index === 0}
                iconOnly={true}
                size="sm"
                variant="tertiary"
                onClick={() => {
                    if (index > 0) {
                        onMove(index - 1);
                    }
                }}
            >
                <IconArrowUp />
            </Button>
            <Button
                aria-label={translate(profileTaskTranslationKeys.moveDown)}
                aria-disabled={index === total - 1}
                iconOnly={true}
                size="sm"
                variant="tertiary"
                onClick={() => {
                    if (index < total - 1) {
                        onMove(index + 1);
                    }
                }}
            >
                <IconArrowDown />
            </Button>
        </div>
    );
};
